module.exports = __webpack_public_path__ + "assets/img/international.256537bf.svg";